"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreBlockHandler = void 0;
const core_handler_1 = require("./core-handler");
/**
 * Implements the Block Protocol Core Specification for blocks.
 */
class CoreBlockHandler extends core_handler_1.CoreHandler {
    constructor({ element }) {
        super({ element, sourceType: "block" });
        this.sentInitMessage = false;
    }
    /**
     * Send the init message, to which an initResponse is expected from the embedder.
     * The response will be processed in {@link processInitMessage}
     *
     * We send it repeatedly because the embedder may not yet have attached
     * its listeners
     */
    initialize() {
        if (!this.sentInitMessage) {
            this.sentInitMessage = true;
            void this.sendInitMessage().then(() => {
                this.afterInitialized();
            });
        }
    }
    sendInitMessage() {
        const resp = this.sendMessage({
            partialMessage: { messageName: "init" },
            respondedToBy: "initResponse",
            sender: this,
        });
        return Promise.race([
            resp,
            new Promise((resolve) => {
                queueMicrotask(resolve);
            }),
        ]).then((response) => {
            if (!response) {
                return this.sendInitMessage();
            }
        });
    }
    /**
     * Receives the {@link EmbedderInitMessage} sent by the embedding application,
     * which is a series of payloads namespaced by module and message name.
     * Calls the individual callbacks registered for each of these values.
     *
     * Useful for HTML blocks receiving messages which are sent on initialization by the app
     * – other types of blocks can receive these messages synchronously via properties.
     */
    processInitMessage({ message, }) {
        const { data } = message;
        for (const moduleName of Object.keys(data)) {
            for (const messageName of Object.keys(data[moduleName])) {
                void this.callCallback({
                    message: {
                        ...message,
                        data: data[moduleName][messageName],
                        messageName,
                        module: moduleName,
                    },
                });
            }
        }
    }
}
exports.CoreBlockHandler = CoreBlockHandler;
//# sourceMappingURL=core-block-handler.js.map